/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */

import { initializeApp, getApps, getApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, signInWithPopup } from 'firebase/auth';
import { getFirestore, initializeFirestore } from 'firebase/firestore';
import firebaseConfig from '../../firebase-applet-config.json';

// Initialize Firebase App instance safely (singleton)
const app = getApps().length === 0 ? initializeApp(firebaseConfig) : getApp();

// Initialize Authentication
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();

// Database ID specified in firebase-applet-config.json
const databaseId = firebaseConfig.firestoreDatabaseId || "ai-studio-20b4580c-068d-482b-a973-3ca01e1c04a8";

// Initialize Firestore safely according to Firebase SDK guidelines
let firestoreInstance: any;
try {
  firestoreInstance = getFirestore(app, databaseId);
  console.log(`[Firestore] Connected to database: ${databaseId}`);
} catch (err1) {
  console.warn('[Firestore] getFirestore custom database fallback to initializeFirestore:', err1);
  try {
    firestoreInstance = initializeFirestore(app, {}, databaseId);
  } catch (err2) {
    try {
      firestoreInstance = getFirestore(app);
    } catch (err3) {
      console.error('[Firestore] Database initialization error:', err3);
    }
  }
}

export const db = firestoreInstance;

export { signInWithPopup };
export default app;
